var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 时间选择组合框
 * @author (zhanghao14)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Select from './Select';
import { noop, classPrefix } from '../../common/util';

var formatOption = function formatOption(option) {
    var value = option.value,
        disabled = option.disabled;

    var formatValue = void 0;
    if (value < 10) {
        formatValue = '0' + value;
    } else {
        formatValue = '' + value;
    }

    return {
        value: formatValue,
        disabled: disabled
    };
};
var generateOptions = function generateOptions(length) {
    var disabledOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var arr = [];
    for (var value = 0; value < length; value++) {
        arr.push({ value: value, disabled: disabledOptions.indexOf(value) >= 0 });
    }
    return arr;
};

/**
 * 参数说明
 * className                  可选，自定义样式类名
 * prefixCls                  可选，类名前缀
 * format                     可选，时间显示格式，默认格式是HH:mm
 * value                      可选，显示的时间，moment 对象
 * defaultOpenValue           可选，默认显示时间，默认是当前时间
 * showHour                   可选，是否显示小时，默认显示
 * showMinute                 可选，是否显示分钟，默认显示
 * showSecond                 可选，是否显示秒， 默认显示
 * onCurrentSelectPanelChange 可选，选择变化时的回调
 * use12Hours                 可选，是否按照12小时显示，默认按照24小时显示
 */

var Combobox = function (_Component) {
    _inherits(Combobox, _Component);

    function Combobox(props) {
        _classCallCheck(this, Combobox);

        var _this = _possibleConstructorReturn(this, (Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call(this, props));

        _this.state = {};
        _this.onItemChange = _this.onItemChange.bind(_this);
        return _this;
    }

    _createClass(Combobox, [{
        key: 'onItemChange',
        value: function onItemChange(itemValue, type) {
            var _props = this.props,
                onChange = _props.onChange,
                defaultOpenValue = _props.defaultOpenValue,
                use12Hours = _props.use12Hours;


            var value = (this.props.value || defaultOpenValue).clone();
            if (type === 'hour') {
                if (use12Hours) {
                    if (this.isAM()) {
                        value.hour(+itemValue % 12);
                    } else {
                        value.hour(+itemValue % 12 + 12);
                    }
                } else {
                    value.hour(+itemValue);
                }
            } else if (type === 'minute') {
                value.minute(+itemValue);
            } else if (type === 'ampm') {
                var ampm = itemValue.toUpperCase();
                if (use12Hours) {
                    if (ampm === 'PM' && value.hour() < 12) {
                        value.hour(value.hour() % 12 + 12);
                    }

                    if (ampm === 'AM') {
                        if (value.hour() >= 12) {
                            value.hour(value.hour() - 12);
                        }
                    }
                }
            } else {
                value.second(+itemValue);
            }
            onChange(value);
        }
    }, {
        key: 'onEnterSelectPanel',
        value: function onEnterSelectPanel(range) {
            this.props.onCurrentSelectPanelChange(range);
        }
    }, {
        key: 'isAM',
        value: function isAM() {
            var value = this.props.value || this.props.defaultOpenValue;
            return value.hour() >= 0 && value.hour() < 12;
        }
    }, {
        key: 'getHourSelect',
        value: function getHourSelect(hour) {
            var _this2 = this;

            var _props2 = this.props,
                hourOptions = _props2.hourOptions,
                showHour = _props2.showHour,
                use12Hours = _props2.use12Hours,
                prefixCls = _props2.prefixCls;


            if (!showHour) {
                return null;
            }
            var hourOptionsAdj = void 0;
            var selectedIndex = -1;
            if (use12Hours) {
                hourOptionsAdj = hourOptions.filter(function (option) {
                    if (_this2.isAM()) {
                        return option.value >= 0 && option.value < 12;
                    } else {
                        return option.value >= 12 && option.value < 24;
                    }
                });
                hourOptionsAdj = hourOptionsAdj.map(function (option, index) {
                    if (hour === option.value) {
                        selectedIndex = index;
                    }
                    if (!_this2.isAM()) {
                        return {
                            value: option.value % 12 || 12,
                            disabled: option.disabled
                        };
                    } else {
                        return option;
                    }
                });
            } else {
                hourOptionsAdj = hourOptions;
                selectedIndex = Object.keys(hourOptionsAdj).indexOf('' + hour);
            }
            var selectProps = {
                prefixCls: prefixCls,
                options: hourOptionsAdj.map(function (option) {
                    return formatOption(option);
                }),
                selectedIndex: selectedIndex,
                type: 'hour',
                onSelect: this.onItemChange,
                onMouseEnter: this.onEnterSelectPanel.bind(this, 'hour')
            };
            return React.createElement(Select, selectProps);
        }
    }, {
        key: 'getMinuteSelect',
        value: function getMinuteSelect(minute) {
            var _props3 = this.props,
                prefixCls = _props3.prefixCls,
                minuteOptions = _props3.minuteOptions,
                showMinute = _props3.showMinute;


            if (!showMinute) {
                return null;
            }
            var selectProps = {
                prefixCls: prefixCls,
                options: minuteOptions.map(function (option) {
                    return formatOption(option);
                }),
                selectedIndex: Object.keys(minuteOptions).indexOf('' + minute),
                type: 'minute',
                onSelect: this.onItemChange,
                onMouseEnter: this.onEnterSelectPanel.bind(this, 'minute')
            };
            return React.createElement(Select, selectProps);
        }
    }, {
        key: 'getSecondSelect',
        value: function getSecondSelect(second) {
            var _props4 = this.props,
                prefixCls = _props4.prefixCls,
                secondOptions = _props4.secondOptions,
                showSecond = _props4.showSecond;


            if (!showSecond) {
                return null;
            }
            var selectProps = {
                prefixCls: prefixCls,
                options: secondOptions.map(function (option) {
                    return formatOption(option);
                }),
                selectedIndex: Object.keys(secondOptions).indexOf('' + second),
                type: 'second',
                onSelect: this.onItemChange,
                onMouseEnter: this.onEnterSelectPanel.bind(this, 'second')
            };
            return React.createElement(Select, selectProps);
        }
    }, {
        key: 'getAMPMSelect',
        value: function getAMPMSelect() {
            var _props5 = this.props,
                prefixCls = _props5.prefixCls,
                use12Hours = _props5.use12Hours,
                format = _props5.format;


            if (!use12Hours) {
                return null;
            }

            var AMPMOptions = ['am', 'pm'].map(function (c) {
                return format.match(/\sA/) ? c.toUpperCase() : c;
            }).map(function (c) {
                return { value: c };
            });

            var selectProps = {
                prefixCls: prefixCls,
                options: AMPMOptions,
                selectedIndex: this.isAM() ? 0 : 1,
                type: 'ampm',
                onSelect: this.onItemChange,
                onMouseEnter: this.onEnterSelectPanel.bind(this, 'ampm')
            };
            return React.createElement(Select, selectProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props6 = this.props,
                prefixCls = _props6.prefixCls,
                defaultOpenValue = _props6.defaultOpenValue;

            var value = this.props.value || defaultOpenValue;
            return React.createElement(
                'div',
                { className: prefixCls + '-combobox' },
                this.getHourSelect(value.hour()),
                this.getMinuteSelect(value.minute()),
                this.getSecondSelect(value.second()),
                this.getAMPMSelect(value.hour())
            );
        }
    }]);

    return Combobox;
}(Component);

export default Combobox;


Combobox.defaultProps = {
    format: 'HH:mm',
    defaultOpenValue: moment(),
    prefixCls: classPrefix + '-time-picker',
    value: null,
    onChange: noop,
    showHour: true,
    showMinute: true,
    showSecond: true,
    hourOptions: generateOptions(24),
    minuteOptions: generateOptions(60),
    secondOptions: generateOptions(60),
    onCurrentSelectPanelChange: noop,
    use12Hours: false
};
Combobox.propTypes = {
    format: PropTypes.string,
    defaultOpenValue: PropTypes.object,
    prefixCls: PropTypes.string,
    value: PropTypes.object,
    onChange: PropTypes.func,
    showHour: PropTypes.bool,
    showMinute: PropTypes.bool,
    showSecond: PropTypes.bool,
    hourOptions: PropTypes.array,
    minuteOptions: PropTypes.array,
    secondOptions: PropTypes.array,
    onCurrentSelectPanelChange: PropTypes.func,
    use12Hours: PropTypes.bool
};